<template>
  <div>
  </div>
</template>

<script>
  export default {
    name: 'Dashboard',
    data: () => ({
    }),
    computed: {
    },
    watch: {
    },
    methods: {
    },
  };
</script>
